import {loadJs} from "../../assets/js/utils.js";

class ArtikelMedien extends HTMLElement {
    connectedCallback() {
        __webpack_public_path__ = `${this.dataset["assetBaseUri"]}/artikel-medien/`;
        this.removeAttribute('data-js');
        this.init3dAnsichtOverlay();
        this.initLeseprobeOverlay();
        this.initAudioPlayer();
        this.initMedienOverlay();
        // Wenn ein Panel mit mehreren Einträgen existiert, laden wir das Custom Element in "tab-panel.js"
        if (this.tabPanelHatMehrereEintraege) {
            this.initPanels();
        }
        this.checkSensitiveContent();
    }

    init3dAnsichtOverlay() {
        this.ansicht3dForm = this.querySelector('.ansicht3d-form');
        if (this.ansicht3dForm === null) return;
        this.ansicht3dForm.addEventListener('submit', (event) => {
            event.preventDefault();
            const ansicht3dOeffnenEvent = new CustomEvent('ansicht3d-oeffnen', { bubbles: true });
            document.dispatchEvent(ansicht3dOeffnenEvent);
        })
    }

    initLeseprobeOverlay() {
        this.leseprobeForm = this.querySelector('.leseprobe-form');
        if (this.leseprobeForm === null) return;
        this.leseprobeForm.addEventListener('submit', (event) => {
            event.preventDefault();
            const leseprobeOeffnenEvent = new CustomEvent('leseprobe-oeffnen', { bubbles: true });
            document.dispatchEvent(leseprobeOeffnenEvent);
        })
    }

    initAudioPlayer() {
        this.audioOeffnenButton = this.querySelector('[interaction="hoerprobe-oeffnen"]');
        if (this.audioOeffnenButton === null) return;
        this.audioOeffnenButton.addEventListener('click', () => {
            const customEvent = new CustomEvent("audioplayer-oeffnen");
            document.dispatchEvent(customEvent);
        })
    }

    initMedienOverlay() {
        this.querySelectorAll('[data-artikelbild-index]').forEach(medium => medium.addEventListener("click", event => {
            this.sendMedienOverlayOeffnenEvent(event);
            this.sendImageZoomInitEvent(event);
        }));
    }

    sendMedienOverlayOeffnenEvent(event) {
        const { target } = event;
        const eventDetail = {
            istEinzelbild: target.closest("[einzelbild]") !== null
        }
        const artikelbild = target.closest("[data-artikelbild-index]");
        if (artikelbild) {
            eventDetail['index'] = artikelbild.getAttribute("data-artikelbild-index");
        }
        target.dispatchEvent(new CustomEvent("medienoverlay-oeffnen", {
            bubbles: true,
            detail: eventDetail
        }));
    }

    sendImageZoomInitEvent(event) {
        const imageZoom = event.target.closest('IMAGE-ZOOM');
        if (imageZoom) {
            const zoomState = imageZoom.getAttribute('enabled') || false;
            const artikelbildIndex = imageZoom.dataset['artikelbildIndex'];
            document.dispatchEvent(new CustomEvent("zoom-state-change", {
                detail: {
                    artikelbildIndex: parseInt(artikelbildIndex),
                    zoomState: zoomState
                }
            }));
        }
    }

    async initPanels() {
        const { TabPanel } = await import(/* webpackChunkName: "tab-panel" */ "./tab-panel.js");
    }

    get tabPanelHatMehrereEintraege() {
        const tabPanels = this.querySelectorAll("tab-panel");
        for (const panel of tabPanels) {
            const entries = panel.querySelectorAll(".tab-liste-eintrag");
            if (entries.length === 0) {
                return false;
            }
            return true;
        }
        return false;
    }

    hideSensitiveContent(tabItems) {
        for (const tab of tabItems) {
            tab.parentElement.removeChild(tab);
        }
    }

    showSensitiveContent(tabItems) {
        for (const tab of tabItems) {
            tab.classList.remove('hidden')
        }
    }

    async checkSensitiveContent() {
        const tabItemsAb18 = this.querySelectorAll(".medien-stage .nicht-jugendfrei");
        if (tabItemsAb18.length > 0) {
            try {
                const requestUrl = '/artikeldetailseite/api/rest/isLoggedIn';
                const response = await fetch(requestUrl, {
                    method: "GET"
                });
                if (response.status === 200 && await response.json() === true) {
                    this.showSensitiveContent(tabItemsAb18);
                    return;
                }
                this.hideSensitiveContent(tabItemsAb18);
            } catch (error) {
                console.error(error);
            }
        }
    }
}

if (!customElements.get("artikel-medien")) {
    customElements.define("artikel-medien", ArtikelMedien);
}
